import axios from './axios'
// _makeRequest---------------------------------------------------------------------------------------
const _makeRequest = (requestConfig) => {
  return new Promise((resolve, reject) => {

    axios(requestConfig)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        const error = {
          message: err.response ? err.response.data : 'Unknown error try it later',
          code : err.response ? err.response.status || null : null
        };
        reject(error);
      })
  })
};

//Request IDN API Methods-----------------------------------------------------------------------------
const signup = ({email, password}) => {
  return new Promise((resolve, reject) => {
    const requestConfig = {
      method: 'post',
      url: `/users`,
      data: {
        email,
        password
      }
    }
    _makeRequest(requestConfig)
      .then(result => {
        resolve(result)
      })
      .catch(err => {
          reject(err);
      })
  })
}
const resendEmailVerification = ({userID}) => {
  return new Promise((resolve, reject) => {
    const requestConfig = {
      method: 'post',
      url: `/users/${userID}/sendVerifyEmail`,
      data: {}
    }
    _makeRequest(requestConfig)
      .then(result => {
        resolve(result)
      })
      .catch(err => {
        reject(err);
      })
  })
}
const emailVerification = ({token}) => {
  return new Promise((resolve, reject) => {
    const requestConfig = {
      method: 'post',
      url: `/users/verifyEmail`,
      data: {
        token
      }
    }
    _makeRequest(requestConfig)
      .then(result => {
        resolve(result)
      })
      .catch(err => { // pending
        let error = '';
        switch(err.code){
          case 400:
            error = 'token expired';
            break;
          case 409:
            error = "";
            break;
          default:
            error = 'Unknown error try it later';
        }
        reject(error);
      })
  })
}
const login = (data) => {
  return new Promise((resolve, reject) => {
    const requestConfig = {
      method: 'post',
      url: `/login`,
      data
    }
    _makeRequest(requestConfig)
      .then(result => {
        resolve(result) // debe llegar token, userId, permisos
      })
      .catch(err => {
        let error = '';
          switch(err.code){
            case 400:
            case 401:
              error = 'User or password invalid';
              break;
            case 409:
              error = "User not verified, check email";
              break;
            default:
              error = 'Unknown error try it later';
          }
          reject(error);
      })
  })
}
const recover = ({email}) => {
  return new Promise((resolve, reject) => {
    const requestConfig = {
      method: 'post',
      url: `/users/resetPassword`,
      data: {
        email
      }
    }
    _makeRequest(requestConfig)
      .then(result => {
        resolve(result) // debe llegar token, userId, permisos
      })
      .catch(err => {
          reject(err);
      })
  })
}

export default {
    signup,
    resendEmailVerification,
    emailVerification,
    login,
    recover
  }